import React from 'react';
import { TypingIndicatorProps } from './types';

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="flex gap-3 animate-fade-in">
      {/* Avatar */}
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-dark-tertiary border border-dark-tertiary flex items-center justify-center">
        <div className="w-3 h-3 bg-primary-500 rounded-full animate-pulse"></div>
      </div>

      {/* Typing Bubble */}
      <div className="flex flex-col items-start">
        <div className="bg-dark-tertiary border border-dark-tertiary/50 rounded-2xl rounded-bl-md px-4 py-3 relative">
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
          
          {/* Message tail */}
          <div className="absolute bottom-0 left-0 -translate-x-0 translate-y-full border-r-8 border-r-dark-tertiary border-t-8 border-t-transparent border-b-8 border-b-transparent" />
        </div>

        {/* Status Text */}
        <div className="text-xs text-light-tertiary mt-1 px-1 flex items-center gap-1">
          <div className="w-1.5 h-1.5 bg-primary-500 rounded-full animate-pulse"></div>
          <span>Insurance Assistant is analyzing your question...</span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;